import axios from 'axios'
export default {
    namespaced: true,
    state: {
		name: 'VehicleGearbox',
		endpoint: '/vehicle/gearbox',
        items: [],
    },
    actions: {
		load (context, params) {
			return axios.get(`/vehicle/category/${params.category.id}/gearbox`).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data)
			}, error => {
				console.log(error)
			})
		},
    }
}